import { render, staticRenderFns } from "./nl-faq.vue?vue&type=template&id=73cbd100&"
import script from "./nl-faq.vue?vue&type=script&lang=js&"
export * from "./nl-faq.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports